import type EstimateValues from "../../../../types/params"
import replaceBeatenThickness from "./replaceBeatenThickness"
import replaceBonding from "./replaceBonding"
import replaceBuildUpMethod from "./replaceBuildUpMethod"
import replaceDataService from "./replaceDataService"
import replaceEmcShield from "./replaceEmcShield"
import replaceFpcBoardThickness from "./replaceFpcBoardThickness"

/**
 * 表示名は一緒だが、内部的に別のコード値として扱ってるvalueの置換をします。
 * ただしコード値の違いが基板の種類のみに依存している以下の項目は処理を行いません。（基板の種類変更時は入力内容をリセットするため）
 * ・最小ビア／ランド経
 * ・レジスト色
 * ・シルク印刷色
 * ・表面処理
 * ・製造工場
 */
const replaceValues = (values: EstimateValues): EstimateValues => {
  return {
    ...values,
    ...replaceBonding(values),
    fpcBoardThickness: replaceFpcBoardThickness(values),
    beatenThickness: replaceBeatenThickness(values),
    buildUpMethod: replaceBuildUpMethod(values),
    emcShield: replaceEmcShield(values),
    dataService: replaceDataService(values),
  }
}

export default replaceValues
